import { onSelectedCalendarIdsUpdated } from '../actions/publicActions';
import { hasTimePanelSelectedCalendars } from '../selectors/hasTimePanelSelectedCalendars';
import { selectedCalendarsUpdated } from 'owa-calendar-module-selected-calendars-user-config';
import { orchestrator } from 'satcheljs';

/**
 * Stopgap to keep Time Panel in-sync with left-nav selection changes in Calendar module
 * until Time Panel selected calendars feature lights up
 *
 * NOTE: Delete this orchestrator once VSO #54134 is complete
 */
export const selectedCalendarsUpdatedOrchestrator = orchestrator(
    selectedCalendarsUpdated,
    actionMessage => {
        const { calendarIds, primarySmtpAddress } = actionMessage;
        if (!hasTimePanelSelectedCalendars()) {
            onSelectedCalendarIdsUpdated(calendarIds, primarySmtpAddress);
        }
    }
);
